module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_babel-runtime@6.26.0@babel-runtime/core-js/object/define-property.js
// module id = 169
// module chunks = 0